const CodeTrades = () => import(/* webpackChunkName: "proj" */ './Trades');
const CodeIndustryPark = () => import(/* webpackChunkName: "proj" */ './park/IndustryPark');
const CodeDistrict = () => import(/* webpackChunkName: "proj" */ './District');
const CodeReviewAuth = () => import(/* webpackChunkName: "proj" */ './review/ReviewAuth');



export default {
  routes: [
    //行业领域
    {
      path: '/code/trades',
      name: 'code_trades',
      component: CodeTrades
    },
    //工业园区
    {
      path: '/code/industrypark',
      name: 'code_industry_park',
      component: CodeIndustryPark
    },
    //行政区划代码
    {
      path: '/code/district',
      name: 'code_district',
      component: CodeDistrict
    },
    //权限控制
    {
      path: '/code/reviewauth',
      name: 'code_reviewauth',
      component: CodeReviewAuth
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/code/router.js